export default function BuyTicketPage() {
  return (
    <div
      className="relative bg-contain h-full  bg-repeat   text-white "

    >
      {/* СИЛЬНЫЙ FADE ЭФФЕКТ СВЕРХУ */}
      <div className="absolute top-0 left-0 right-0 h-[500px] bg-gradient-to-b from-[#0B0E30] to-transparent z-0"></div>

      <div className="pt-40 pb-40 text-center px-4 relative z-10">
        <h1 className="text-[80px] md:text-[120px] font-bold leading-none text-[#B1B3F8]">
          Buy <span className="text-[#A1A3F7] font-extrabold">Ticket</span>
        </h1>

<div className="pt-20">

<p className="text-[#0066CC] font-bold text-4xl mt-10"> Let's Book Your Ticket </p>
 <p className="text-[#0066CC] font-bold text-xl mt-2"> Please fill your personal information, choose date, and ticket </p>

</  div>
      </div>
    </div>
  );
}
